// extracted by mini-css-extract-plugin
export var banner = "_ev-0";
export var closeButton = "_ev-2";
export var greenCheckmark = "_ev-3";
export var hereLink = "_ev-4";
export var titleIcon = "_ev-1";